"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isUserVisibleMetric = exports.ALL_USER_VISIBLE_METRICS = exports.SUPPORTED_CATEGORICAL_METRICS_FRONTEND = exports.SUPPORTED_NUMERIC_METRICS_FRONTEND = exports.SUPPORTS_DEEP_DIVE_SUB_METRICS = exports.SUPPORTS_DEEP_DIVE_INSIGHTS = void 0;
const lodash_1 = require("lodash");
const skin_1 = require("./skin");
/**
 * Metrics that support deep dive insights and are visible to users
 * These are the core actionable metrics that users can track over time
 *
 * ORDERED LIST OF METRICS. DO NOT CHANGE THE ORDER OF THE METRICS.
 * DICTATES THE ORDER OF THE DEEP DIVE METRICS IN THE UI
 *
 * Order follows SkinMetricGroupTechNameMap groups (excluding baseline_properties):
 * 1. skin_sensitivity
 * 2. clarity_breakouts
 * 3. tone_evenness
 * 4. structure_aging
 * 5. eye_area
 */
exports.SUPPORTS_DEEP_DIVE_INSIGHTS = [
    // ─── GROUP 1: Skin Sensitivity (6 metrics) ───
    skin_1.SkinMetricTechName.hydration,
    skin_1.SkinMetricTechName.texture_roughness,
    skin_1.SkinMetricTechName.redness,
    skin_1.SkinMetricTechName.surface_sebum,
    skin_1.SkinMetricTechName.telangiectasia,
    // ─── GROUP 2: Clarity & Breakouts (3 metrics) ───
    skin_1.SkinMetricTechName.breakouts,
    skin_1.SkinMetricTechName.pores,
    skin_1.SkinMetricTechName.pie,
    // ─── GROUP 3: Tone Evenness (4 metrics) ───
    skin_1.SkinMetricTechName.pigmentation,
    skin_1.SkinMetricTechName.sun_spots,
    skin_1.SkinMetricTechName.melasma,
    skin_1.SkinMetricTechName.freckles,
    // ─── GROUP 4: Structure & Agingr (7 metrics) ───
    skin_1.SkinMetricTechName.lines,
    skin_1.SkinMetricTechName.fine_lines,
    skin_1.SkinMetricTechName.deep_lines,
    skin_1.SkinMetricTechName.nasolabial_wrinkles,
    skin_1.SkinMetricTechName.marionette_lines,
    skin_1.SkinMetricTechName.sagging,
    skin_1.SkinMetricTechName.jowls,
    // ─── GROUP 5: Eye Area (4 metrics) ───
    skin_1.SkinMetricTechName.dark_circles,
    skin_1.SkinMetricTechName.puffiness,
    skin_1.SkinMetricTechName.eye_bags,
    skin_1.SkinMetricTechName.lacrimal_grooves,
];
/**
 * Sub-metrics that are visible on the metrics dashboard but NOT in the deep dive carousel
 * Currently empty - all metrics from SkinMetricGroupTechNameMap are now in SUPPORTS_DEEP_DIVE_INSIGHTS
 * Kept for future metrics that should appear on dashboard only
 */
exports.SUPPORTS_DEEP_DIVE_SUB_METRICS = [];
/**
 * Additional numeric metrics visible on frontend
 * (not in deep dive but still shown to users)
 */
exports.SUPPORTED_NUMERIC_METRICS_FRONTEND = [
    skin_1.SkinMetricTechName.age,
    skin_1.SkinMetricTechName.eyes_age,
];
/**
 * Categorical metrics visible on frontend
 * (classification-based, not numeric trends)
 */
exports.SUPPORTED_CATEGORICAL_METRICS_FRONTEND = [
    skin_1.SkinMetricTechName.skin_type,
    skin_1.SkinMetricTechName.skintone,
];
/**
 * All metrics visible to users
 */
exports.ALL_USER_VISIBLE_METRICS = (0, lodash_1.uniq)([
    ...exports.SUPPORTS_DEEP_DIVE_INSIGHTS,
    ...exports.SUPPORTS_DEEP_DIVE_SUB_METRICS,
    ...exports.SUPPORTED_NUMERIC_METRICS_FRONTEND,
    ...exports.SUPPORTED_CATEGORICAL_METRICS_FRONTEND,
]);
/**
 * Check if a metric is visible to users
 */
const isUserVisibleMetric = (techName) => {
    return exports.ALL_USER_VISIBLE_METRICS.includes(techName);
};
exports.isUserVisibleMetric = isUserVisibleMetric;
//# sourceMappingURL=metricVisibility.js.map